export default "__VITE_ASSET__DxrJ8uMI__"